import { useState } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Player from './components/Player/Player';



function App() {
  


  return (
    <div>
      <Header></Header>
      <Player></Player>
  
      
    </div>
  );
}

export default App;
